import { proxy } from 'valtio'
import { useSnapshot } from 'valtio'

/**
 * 编辑权限 store — 控制画布编辑模式的全局标志。
 * 放在 shared 层，已收拢为私有变量，外部只能通过导出的 Hook 和方法访问。
 */
export type PermissionState = 'edit' | 'readonly'

interface FlowPermissionState {
  flowMode: PermissionState
  shardMode: boolean // 项目是否是分享模式
}

const flowPermissionStore = proxy<FlowPermissionState>({
  flowMode: 'edit',
  shardMode: false,
})

// 提供给 React 组件使用的响应式只读 Hook，避免外部直接修改 store
export function useFlowPermission() {
  const snap = useSnapshot(flowPermissionStore)
  return {
    flowMode: snap.flowMode,
    shardMode: snap.shardMode,
    isReadonly: snap.shardMode || snap.flowMode === 'readonly',
  }
}

// 提供给非 React 模块（或者不需要响应式的场景）的普通只读 Getter
export function getFlowPermission() {
  return {
    flowMode: flowPermissionStore.flowMode,
    shardMode: flowPermissionStore.shardMode,
    isReadonly: flowPermissionStore.shardMode || flowPermissionStore.flowMode === 'readonly',
  }
}

// 统一修改状态的 Actions
export function setFlowPermissionMode(mode: PermissionState) {
  flowPermissionStore.flowMode = mode
}

export function setFlowShardMode(mode: boolean) {
  flowPermissionStore.shardMode = mode
}
